import { useState, useCallback } from "react";

/**
 * Custom hook to manage collapse state for multiple categories
 */
export const useCategoryCollapse = () => {
    const [openCategories, setOpenCategories] = useState<Record<string, boolean>>({});

    const toggleCategory = useCallback((categoryName: string) => {
        setOpenCategories(prev => ({
            ...prev,
            [categoryName]: !prev[categoryName]
        }));
    }, []);

    const isCategoryOpen = useCallback((categoryName: string): boolean => {
        return openCategories[categoryName] || false;
    }, [openCategories]);

    return {
        toggleCategory,
        isCategoryOpen
    };
};
